import { Box, Typography } from '@mui/material';

interface ObjectCategoryProps {
    title: string;
    children: React.ReactNode;
}

const ObjectCategory = ({ title, children }: ObjectCategoryProps) => {
    return (
        <Box>
            <Typography variant="subtitle2" color="primary" gutterBottom>
                {title}
            </Typography>
            {children}
        </Box>
    );
};

export default ObjectCategory;
